<template>
  <div style="position: relative;">
    <el-form ref="flowWorkInformation" :model="flowWorkInformation" label-width="100px" :size="defaultFormItemSize" label-position="right" @submit.native.prevent>
      <filter-box :item-width="350">
        <el-form-item label="工单状态" prop="formFilter.flowStatus">
          <el-select class="filter-item" v-model="flowWorkInformation.formFilter.flowStatus" :clearable="true"
            placeholder="工单状态">
            <el-option v-for="item in SysFlowWorkOrderStatus.getList()" :key="item.id"
              :label="item.name" :value="item.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="创建日期" prop="formFilter.createTime">
          <date-range class="filter-item" v-model="flowWorkInformation.formFilter.createTime" :clearable="true" :allowTypes="['day']" align="left"
            range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期"
            format="yyyy-MM-dd" value-format="yyyy-MM-dd HH:mm:ss" />
        </el-form-item>
        <el-form-item label="工单编号" prop="formFilter.workOrderCode">
          <el-input class="filter-item" v-model="flowWorkInformation.formFilter.workOrderCode"
            :clearable="true" placeholder="工单编号"
          />
        </el-form-item>
        <el-form-item label="内容" prop="formFilter.queryForm.workContent">
          <el-input class="filter-item" v-model="flowWorkInformation.formFilter.queryForm.workContent"
                    :clearable="true" placeholder="内容"
          />
        </el-form-item>
        <el-form-item label="创建人" prop="formFilter.createUserName">
          <el-input class="filter-item" v-model="flowWorkInformation.formFilter.createUserName"
                    :clearable="true" placeholder="创建人名称"
          />
        </el-form-item>
        <el-form-item label="流程状态" prop="formFilter.latestApprovalStatus">
          <el-select class="filter-item" v-model="flowWorkInformation.formFilter.latestApprovalStatus"
                     :clearable="true" filterable
                     placeholder="" :loading="flowWorkInformation.latestApprovalStatus.impl.loading"
                     @visible-change="flowWorkInformation.latestApprovalStatus.impl.onVisibleChange"
          >
            <el-option v-for="item in flowWorkInformation.latestApprovalStatus.impl.dropdownList" :key="item.id"
                       :value="item.id" :label="item.name"
            />
          </el-select>
        </el-form-item>
        <el-button slot="operator" type="default" :plain="true" :size="defaultFormItemSize" @click="onReset">重置</el-button>
        <el-button slot="operator" type="primary" :plain="true" :size="defaultFormItemSize" @click="refreshFlowWorkInformation(true)">查询</el-button>
<!--        <el-button slot="operator" type="primary" :size="defaultFormItemSize"-->
<!--                   @click="onStartTaskClick()">-->
<!--          新建-->
<!--        </el-button>-->
      </filter-box>
    </el-form>
    <el-table ref="workInformation"
      :data="workInformationWidget.dataList"
      :size="defaultFormItemSize"
      :seq-config="{startIndex: ((workInformationWidget.currentPage - 1) * workInformationWidget.pageSize)}"
      @sort-change="workInformationWidget.onSortChange"
      header-cell-class-name="table-header-gray"
    >

      <el-table-column label="序号" header-align="center" align="center" type="index" width="55px"
                       :index="workInformationWidget.getTableIndex"
      />
      <el-table-column label="工单编号" prop="workOrderCode" />
      <el-table-column label="创建人" prop="userShowName" />

      <el-table-column label="日志主题" prop="masterData.workContent" />
      <el-table-column label="附件" min-width="180px">
        <template slot-scope="scope">
          <el-image v-for="item in parseUploadData(scope.row.masterData.attachedFiles, {id: scope.row.masterData.id, fieldName: 'attachedFiles', asImage: true})"
            :preview-src-list="getPictureList(scope.row.masterData.attachedFiles, {id: scope.row.masterData.id, fieldName: 'attachedFiles', asImage: true})"
            class="table-cell-image" :key="item.url" :src="item.url" fit="fill">
            <div slot="error" class="table-cell-image">
              <i class="el-icon-picture-outline"></i>
            </div>
          </el-image>
        </template>
      </el-table-column>
<!--      <el-table-column label="创建时间" prop="masterData.createTime">-->
<!--        <template slot-scope="scope">-->
<!--          <span>{{formatDateByStatsType(scope.row.masterData.createTime, 'day')}}</span>-->
<!--        </template>-->
<!--      </el-table-column>-->
      <el-table-column label="当前任务" prop="runtimeTaskInfo.taskName" />
      <el-table-column label="流程创建时间" prop="createTime" />
      <el-table-column label="流程状态" prop="latestApprovalStatusDictMap.name" width="100px" />
      <el-table-column label="工单状态" prop="flowStatus"  width="100px">
        <template slot-scope="scope">
          <span>{{SysFlowWorkOrderStatus.getValue(scope.row.flowStatus)}}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="150px" fixed="right">
        <template slot-scope="scope">
          <el-button type="text" :size="defaultFormItemSize"
            v-if="(scope.row.initTaskInfo || {}).taskKey !== (scope.row.runtimeTaskInfo || {}).taskKey"
            @click.stop="onViewTaskClick(scope.row)">
            详情
          </el-button>
<!--          <el-button type="text" :size="defaultFormItemSize"-->
<!--            v-if="(scope.row.initTaskInfo || {}).taskKey === (scope.row.runtimeTaskInfo || {}).taskKey"-->
<!--            @click.stop="onHandlerTaskClick(scope.row)">-->
<!--            办理-->
<!--          </el-button>-->
          <el-button type="text" :size="defaultFormItemSize" class="table-btn"
            @click.stop="onRemindClick(scope.row)">
            催办
          </el-button>
          <el-button type="text" :size="defaultFormItemSize" class="table-btn error"
            @click.stop="onCancelTaskClick(scope.row)">
            撤销
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-row type="flex" justify="end" style="margin-top: 10px;">
      <el-pagination
        :total="workInformationWidget.totalCount"
        :current-page="workInformationWidget.currentPage"
        :page-size="workInformationWidget.pageSize"
        :page-sizes="[10, 20, 50, 100]"
        layout="total, prev, pager, next, sizes"
        @current-change="workInformationWidget.onCurrentPageChange"
        @size-change="workInformationWidget.onPageSizeChange">
      </el-pagination>
    </el-row>
  </div>
</template>

<script>
import '@/staticDict/flowStaticDict.js';
/* eslint-disable-next-line */
import { DropdownWidget, TableWidget, UploadWidget, ChartWidget } from '@/utils/widget.js';
/* eslint-disable-next-line */
import { uploadMixin, statsDateRangeMixin, cachePageMixin } from '@/core/mixins';
/* eslint-disable-next-line */
import { WorkInformationController, DictionaryController } from '@/api';
/* eslint-disable-next-line */
import { FlowOperationController } from '@/api/flowController.js';

const processDefinitionKey = 'flowWorkInformation';
const processDefinitionName = '工作日志流程';

export default {
  name: 'flowWorkInformation',
  props: {
  },
  mixins: [uploadMixin, statsDateRangeMixin, cachePageMixin],
  data () {
    return {
      flowWorkInformation: {
        formFilter: {
          flowStatus: undefined,
          workOrderCode: undefined,
          createTime: [],
          latestApprovalStatus: undefined,
          createUserName: undefined,
          queryForm: {}

        },
        formFilterCopy: {
          flowStatus: undefined,
          workOrderCode: undefined,
          createTime: [],
          latestApprovalStatus: undefined,
          createUserName: undefined,
          queryForm: {}

        },
        latestApprovalStatus: {
          impl: new DropdownWidget(this.loadLatestApprovalStatusDropdownList)
        },
        isInit: false
      },
      workInformationWidget: new TableWidget(this.loadWorkInformationData, this.loadWorkInformationVerify, true, false)
    }
  },
  methods: {
    onReset () {
      this.$refs.flowWorkInformation.resetFields();
      this.refreshFlowWorkInformation(true);
    },
    loadWorkInformationData (params) {
      if (params == null) params = {};
      params = {
        ...params,
        flowWorkOrderDtoFilter: {
          flowStatus: this.flowWorkInformation.formFilterCopy.flowStatus,
          workOrderCode: this.flowWorkInformation.formFilterCopy.workOrderCode,
          queryForm: this.flowWorkInformation.formFilterCopy.queryForm,
          createUserName: this.flowWorkInformation.formFilterCopy.createUserName,
          latestApprovalStatus: this.flowWorkInformation.formFilterCopy.latestApprovalStatus,
          createTimeStart: Array.isArray(this.flowWorkInformation.formFilterCopy.createTime) ? this.flowWorkInformation.formFilterCopy.createTime[0] : undefined,
          createTimeEnd: Array.isArray(this.flowWorkInformation.formFilterCopy.createTime) ? this.flowWorkInformation.formFilterCopy.createTime[1] : undefined
        },
        orderParam: [
          {
            fieldName: 'createTime',
            asc: false
          }
        ]
      }
      return new Promise((resolve, reject) => {
        WorkInformationController.listWorkOrderFlowWorkInformation(this, params).then(res => {
          let dataList = res.data.dataList.map(item => {
            item.initTaskInfo = JSON.parse(item.initTaskInfo);
            item.runtimeTaskInfo = Array.isArray(item.runtimeTaskInfoList) ? item.runtimeTaskInfoList[0] : undefined;
            item.masterData = item.masterData || {};
            return item;
          });
          resolve({
            dataList: dataList,
            totalCount: res.data.totalCount
          });
        }).catch(e => {
          reject(e);
        })
      });
    },
    loadWorkInformationVerify () {
      this.flowWorkInformation.formFilterCopy.flowStatus = this.flowWorkInformation.formFilter.flowStatus;
      this.flowWorkInformation.formFilterCopy.workOrderCode = this.flowWorkInformation.formFilter.workOrderCode;
      this.flowWorkInformation.formFilterCopy.createTime = this.flowWorkInformation.formFilter.createTime;
      this.flowWorkInformation.formFilterCopy.queryForm = this.flowWorkInformation.formFilter.queryForm;
      this.flowWorkInformation.formFilterCopy.createUserName = this.flowWorkInformation.formFilter.createUserName;
      this.flowWorkInformation.formFilterCopy.latestApprovalStatus = this.flowWorkInformation.formFilter.latestApprovalStatus;
      return true;
    },
    // 启动流程
    onStartTaskClick () {
      let params = {
        processDefinitionKey: processDefinitionKey
      }

      FlowOperationController.viewInitialTaskInfo(this, params).then(res => {
        if (res.data && res.data.taskType === this.SysFlowTaskType.USER_TASK && res.data.assignedMe) {
          this.$router.push({
            name: res.data.routerName || 'handlerFlowTask',
            query: {
              processDefinitionKey: processDefinitionKey,
              formId: res.data.formId,
              routerName: res.data.routerName,
              readOnly: res.data.readOnly,
              taskName: '启动流程',
              isDraft: true,
              isPreview: false,
              flowEntryName: processDefinitionName,
              variableList: res.data.variableList,
              operationList: (res.data.operationList || []).filter(item => {
                return item.type !== this.SysFlowTaskOperationType.CO_SIGN && item.type !== this.SysFlowTaskOperationType.REVOKE;
              })
            }
          });
        } else {
          FlowOperationController.startOnly(this, {
            processDefinitionKey: processDefinitionKey
          }).then(res => {
            this.$message.success('启动成功！');
          }).catch(e => {});
        }
      }).catch(e => {});
    },
    // 办理流程
    onHandlerTaskClick (row) {
      let taskId = (Array.isArray(row.runtimeTaskInfoList) && row.runtimeTaskInfoList.length > 0) ? row.runtimeTaskInfoList[0].taskId : undefined;
      let params = {
        processInstanceId: row.processInstanceId,
        processDefinitionId: row.processDefinitionId,
        taskId: taskId
      }

      FlowOperationController.viewRuntimeTaskInfo(this, params).then(res => {
        if (res.data) {
          this.$router.push({
            name: res.data.routerName || 'handlerFlowTask',
            query: {
              isRuntime: true,
              isDraft: row.flowStatus === this.SysFlowWorkOrderStatus.DRAFT,
              taskId: taskId,
              processDefinitionKey: processDefinitionKey,
              processInstanceId: row.processInstanceId,
              processDefinitionId: row.processDefinitionId,
              formId: res.data.formId,
              routerName: res.data.routerName,
              readOnly: res.data.readOnly,
              taskName: (row.runtimeInitialTask || {}).taskName,
              flowEntryName: row.processDefinitionName,
              processInstanceInitiator: row.processInstanceInitiator,
              operationList: (res.data.operationList || []).filter(item => {
                return item.type !== this.SysFlowTaskOperationType.CO_SIGN && item.type !== this.SysFlowTaskOperationType.REVOKE;
              }),
              variableList: res.data.variableList
            }
          });
        }
      }).catch(e => {});
    },
    // 查看流程
    onViewTaskClick (row) {
      let params = {
        processInstanceId: row.processInstanceId
      }
      let taskId = (Array.isArray(row.runtimeTaskInfoList) && row.runtimeTaskInfoList.length > 0) ? row.runtimeTaskInfoList[0].taskId : undefined;
      FlowOperationController.viewInitialHistoricTaskInfo(this, params).then(res => {
        if (res.data) {
          this.$router.push({
            name: res.data.routerName || 'handlerFlowTask',
            query: {
              isRuntime: false,
              taskId: taskId,
              processDefinitionKey: row.processDefinitionKey,
              processInstanceId: row.processInstanceId,
              processDefinitionId: row.processDefinitionId,
              routerName: res.data.routerName,
              readOnly: true,
              flowEntryName: row.processDefinitionName,
              processInstanceInitiator: row.processInstanceInitiator
            }
          });
        }
      }).catch(e => {});
    },
    // 催办
    onRemindClick (row) {
      FlowOperationController.remindRuntimeTask(this, {
        workOrderId: row.workOrderId
      }).then(res => {
        this.$message.success('催办成功');
      }).catch(e => {});
    },
    // 撤销流程
    onCancelTaskClick (row) {
      this.$confirm('是否撤销此工单？').then(res => {
        let params = {
          workOrderId: row.workOrderId,
          cancelReason: '主动撤销'
        }

        FlowOperationController.cancelWorkOrder(this, params).then(res => {
          this.$message.success('撤销成功！');
          this.refreshFlowWorkInformation();
        }).catch(e => {});
      }).catch(e => {});
    },
    // 刷新工单
    refreshFlowWorkInformation (reloadData = false) {
      if (reloadData) {
        this.workInformationWidget.refreshTable(true, 1);
      } else {
        this.workInformationWidget.refreshTable();
      }
      if (!this.flowWorkInformation.isInit) {
        // 初始化下拉数据
      }
      this.flowWorkInformation.isInit = true;
    },
    onResume () {
      this.refreshFlowWorkInformation();
    },

    formInit () {
      this.refreshFlowWorkInformation();
    }
  },
  mounted () {
    // 初始化页面数据
    this.formInit();
  },
  watch: {
  }
}
</script>

<style>
</style>
